export default __webpack_public_path__ + "6c284bb210304181daed7cb290ff00e1.png";